  import { useLocalStorage } from '@vueuse/core';
  import { format, parseISO } from 'date-fns';
  import axiosCustom from "@/services/axiosCustom";

  export const globalVariable = {
      siteUrl: 'https://tfonfuar.gifadwork.com/',
      apiUrl: '',
      uploadUrl: '',
      // Reactive token
      token: useLocalStorage('token', ''),

      // Varsayılan görsel yükleme
      varsayilanGorsel(event) {
          event.target.src = this.apiUrl + 'resources/varsayilan.png';
      },

      // Tarih formatını doğrulama
      isValidDateFormat(tarih) {
          const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
          return regex.test(tarih);
      },

      // Router'ı ayarlama
      setRouter(router) {
          this.router = router;
      },

      // Çıkış yapma
      cikisYap() {
          if (this.token.value) {
              this.token.value = '';  // Token'ı temizle
              console.info('Token removed successfully.');
          } else {
              console.warn('No token found.');
          }
          if (this.router) {
              this.router.push({ name: 'Login' });
              
          } else {
              console.warn('Router is not set.');
          }
      },

      formatDateTime(dateTimeString) {
          if (!dateTimeString) {
            return ''; // Veya istediğiniz varsayılan bir değer dönebilirsiniz
          }
        
          try {
            const date = parseISO(dateTimeString); // Geçerli ISO formatı kontrolü
            return `${this.formatTurkishDate(date)}`;
          } catch (error) {
            console.error('Geçersiz tarih formatı:', error);
            return ''; // Hata durumunda boş veya varsayılan bir değer döndürün
          }
        },
        
    
        formatTurkishDate(date) {
          const months = [
            'ocak', 'şubat', 'mart', 'nisan', 'mayıs', 'haziran',
            'temmuz', 'ağustos', 'eylül', 'ekim', 'kasım', 'aralık'
          ];
          return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} ${format(date, 'HH:mm')}`;
        },

      // Para değerini sayıya dönüştürme
      paraIntYap(value) {
          if (value === undefined || typeof value !== 'string') {
              return value;
          }
          const formattedValue = parseFloat(value.replace(/,/g, '').replace(/\s/g, ''));
          return isNaN(formattedValue) ? null : formattedValue;
      },
     jwtkontrol() {
    axiosCustom
        .get('anasayfa/jwtkontrol/')
        .then((response) => {
            if (response.data.status === false) {
                this.token.value = null;  // Global token kullanıldı
                if (this.router) {
                    this.router.push('/login');  // Router'a erişim düzeltildi
                } else {
                    console.warn('Router is not set.');
                }
            }
        })
        .catch((error) => {
            console.error("Veri çekme hatası: ", error);
            this.token.value = null;
            if (this.router) {
                this.router.push('/login');
            } else {
                console.warn('Router is not set.');
            }
        });
},
  };

  // URL'leri güncelle
  globalVariable.apiUrl = globalVariable.siteUrl + 'api/';
  globalVariable.uploadUrl = globalVariable.apiUrl + 'uploads/';




